import { ReactElement } from "react";
import { Typography, Row, Col } from "antd";
import { CustomTooltip } from "src/components/CustomTooltip";

const { Text } = Typography;

export interface SiderLabelValueProps {
  label: string | ReactElement;
  value: string | ReactElement;
  onClick?: () => void;
  tooltip?: string;
  ellipsis?: boolean;
}

export const SiderLabelValue: React.FC<SiderLabelValueProps> = ({
  label,
  value,
  onClick,
  tooltip,
  ellipsis = false,
}) => {
  const valueContent = (
    <div
      style={{
        overflow: ellipsis ? "hidden" : undefined,
        textOverflow: ellipsis ? "ellipsis" : undefined,
        whiteSpace: ellipsis ? "nowrap" : undefined,
      }}
    >
      {value}
    </div>
  );

  return (
    <Row
      style={{
        marginBottom: 8,
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <Col span={12}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {label}
        </Text>
      </Col>
      <Col span={12}>
        {tooltip && ellipsis ? (
          <CustomTooltip content={tooltip} size="medium" mouseEnterDelay={0.1}>
            {valueContent}
          </CustomTooltip>
        ) : (
          valueContent
        )}
      </Col>
    </Row>
  );
};
